import {RELEASED_KEY_SHARES} from '../actionTypes'
import {reducerFactory} from '../../lib/asyncUtil'

export default reducerFactory(RELEASED_KEY_SHARES)
